export default __webpack_public_path__ + "static/region-map-content-image-144ceb4a52b788c1256916c6a45710b6.jpg";